<template>
    <div class="btn row-center" :style="bgStyle()" @click="change">
        <img :src="iconShow()" class="icon" alt="图标">
        <span class="content" :style="fontStyle()">{{content}}</span>
    </div>
</template>

<script>

    export default {
        name: "MenuButton",
        props: {
            // 背景
            bg: Array,
            // 图标
            icons: Array,
            // 内容
            content: String,
            // 参数
            params: Object,
            // 是否选中
            selected: Boolean,
        },
        watch: {
            selected(n, o){
                if(n){
                    this.$emit("onSelected")
                }else {
                    this.$emit("onUnselected")
                }
            }
        },
        methods: {
            /**
             * 背景切换
             */
            bgStyle() {
                return `backgroundImage:url("${this.selected ? this.bg[1] : this.bg[0]}")`
            },
            /*
                图标切换
             */
            iconShow() {
                return this.selected ? this.icons[1] : this.icons[0]
            },
            fontStyle(){
                return this.selected ? `color:#0D94FF;` : `color:#E6F3FD;`
            },
            change(){
                // this.selected = !this.selected
                this.$emit("click")
            }
        }
    }
</script>

<style scoped>
  .row-center {
    display: flex;
    flex-flow: row wrap;
    justify-content: center;
    align-items: center;
  }

  .column-center {
    display: flex;
    flex-flow: column wrap;
    justify-content: center;
    align-items: center;
  }

  .btn {
    width: 160px;
    height: 48px;
    background-size: 100% 100%;
    opacity: 0.9;
    cursor: pointer;
    background-image: url(../assets/img/button.png);
    position: fixed;
    bottom: 5vh;
    left: 8vw;
  }

  .icon{
    width: 32px;
    height: 32px;
    background-image: url(../assets/img/park.png);
    background-size: 100% 100%;
  }

  .content {
    color:#E6F3FD;
    font-size: 18px;
    margin-left: 10px;
  }
</style>